module.exports = __webpack_public_path__ + "images/giftTree/love.39d03796d695ab6c9df7d602a726d200.png";